import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PipelineProvider } from './context/PipelineContext';
import { FeaturesProvider } from './context/FeaturesContext';
import { TerminologyProvider } from './context/TerminologyContext';
import './index.css';
import App from './App';
import { register as registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <PipelineProvider>
          <FeaturesProvider>
            <TerminologyProvider>
              <App />
            </TerminologyProvider>
          </FeaturesProvider>
        </PipelineProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

registerServiceWorker();
